import React from 'react'
import { gql, useMutation, useQuery } from '@apollo/client'
import { toast } from 'react-toastify'

import Notifications from './Notifications'
import withMainLayout from '../../hocs/withMainLayout'
import Loading from '../shared/Loading'
import { useLoading } from '../../context/useLoading'

const GET_NOTIFICATION = gql`
  query {
    notifications {
      id
      headingKZ
      headingRU
      headingEN
      messageKZ
      messageRU
      messageEN
    }
  }
`

const ADD_NOTIFICATION = gql`
  mutation addNotification($input: NotificationInput) {
    addNotification(input: $input) {
      id
      headingKZ
      headingRU
      headingEN
      messageKZ
      messageRU
      messageEN
    }
  }
`
const EDIT_NOTIFICATION = gql`
  mutation updateNotification($id: ID!, $input: NotificationInput) {
    updateNotification(id: $id, input: $input) {
      id
      headingKZ
      headingRU
      headingEN
      messageKZ
      messageRU
      messageEN
    }
  }
`

const DELETE_NOTIFICATION = gql`
  mutation delete($id: ID!) {
    deleteNotification(id: $id) {
      id
    }
  }
`

const NotificationsContainer = () => {
  const { showLoading, hideLoading } = useLoading()
  const [notifications, setNotifications] = React.useState([])
  const { data, loading, error, refetch } = useQuery(GET_NOTIFICATION, {
    onCompleted: data => {
      setNotifications(data.notifications)
    }
  })
  React.useEffect(() => {
    if (data && data.notifications) {
      setNotifications(data.notifications)
    }
  }, [data])

  const [addNotification] = useMutation(ADD_NOTIFICATION, {
    update(cache, { data: { addNotification } }) {
      const { notifications } = cache.readQuery({ query: GET_NOTIFICATION })
      cache.writeQuery({
        query: GET_NOTIFICATION,
        data: {
          notifications: notifications.concat(addNotification)
        }
      })
      hideLoading()
      toast.success('Уведомление добавлено')
    }
  })

  const [editNotification] = useMutation(EDIT_NOTIFICATION, {
    update(cache, { data: { updateNotification } }) {
      const { notifications } = cache.readQuery({ query: GET_NOTIFICATION })
      cache.writeQuery({
        query: GET_NOTIFICATION,
        data: {
          notifications: notifications.map(val => {
            return val.id === updateNotification.id ? updateNotification : val
          })
        }
      })
      hideLoading()
      toast.success('Уведомление обновлено')
    }
  })

  const [deleteNotification] = useMutation(DELETE_NOTIFICATION, {
    update(cache, { data: { deleteNotification } }) {
      const { notifications } = cache.readQuery({ query: GET_NOTIFICATION })
      cache.writeQuery({
        query: GET_NOTIFICATION,
        data: {
          notifications: notifications.filter(
            letter => letter.id !== deleteNotification.id
          )
        }
      })
      hideLoading()
      toast.success('Уведомление удалено')
    }
  })

  const addNotificationHandler = (form, showModal) => {
    form
      .validateFields()
      .then(val => {
        const {
          headingKZ,
          headingRU,
          headingEN,
          messageKZ,
          messageRU,
          messageEN
        } = val
        form.resetFields()
        showLoading()
        addNotification({
          variables: {
            input: {
              headingKZ,
              headingRU,
              headingEN,
              messageKZ,
              messageRU,
              messageEN
            }
          }
        })
      })
      .then(() => {
        hideLoading()
        showModal(false)
      })
  }
  const editNotificationHandler = (form, id, showModal) => {
    form
      .validateFields()
      .then(val => {
        const {
          headingKZ,
          headingRU,
          headingEN,
          messageKZ,
          messageRU,
          messageEN
        } = val
        form.resetFields()
        showLoading()
        editNotification({
          variables: {
            id,
            input: {
              headingKZ,
              headingRU,
              headingEN,
              messageKZ,
              messageRU,
              messageEN
            }
          }
        })
      })
      .then(() => {
        hideLoading()
        showModal(false)
      })
  }

  const deleteNotificationHandler = (id, showModal) => {
    showLoading()
    deleteNotification({
      variables: { id }
    }).then(() => {
      showModal(false)
    })
  }

  if (loading) {
    return <Loading />
  }
  return (
    <Notifications
      {...{
        notifications,
        addNotificationHandler,
        editNotificationHandler,
        deleteNotificationHandler
      }}
    />
  )
}

export default withMainLayout(NotificationsContainer)
